import React, {Component} from 'react';
import {confirm} from 'util/confirm'
import {connect} from 'react-redux'
import ContactTimeline from 'components/UI/ContactTimeline'
import ReactQuill from 'react-quill';
import {fetchContactNotes} from './redux/actions/fetchContactNotes'
import {addContactNotes} from './redux/actions/addContactNotes'
import {deleteContactNotes} from './redux/actions/deleteContactNotes'
import {updateContactNotes} from './redux/actions/updateContactNotes'

import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import __R, { userCan } from 'containers/__R'

import './style.scss'
import locale from './locale'

const mapStateToProps = (state) => ({
  user: state.user,
  contactNotes: state.contactNotes,
  disabledBtn: false,
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchContactNotes: (contactId, callback) => dispatch(fetchContactNotes(contactId, callback)),
    addContactNotes: (contactId, params, callback) => dispatch(addContactNotes(contactId, params, callback)),
    deleteContactNotes: (index, contactId, callback) => dispatch(deleteContactNotes(index, contactId, callback)),
    updateContactNotes: (contactId, params, callback) => dispatch(updateContactNotes(contactId, params, callback)),
	};
};

class ContactNotes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      status: 'view',
      content: '',
      taskId: '',
    }

    this.getContactNotes = this.getContactNotes.bind(this)
    this.editTask = this.editTask.bind(this)
    this.deleteTask = this.deleteTask.bind(this)
  }

	componentDidMount(){
    this.getContactNotes()
	}

  getContactNotes(){
    const {contactId} = this.props

    this.props.fetchContactNotes(contactId, () => {
    })
  }

  editTask(taskId, task){
    this.setState({status: 'edit', content: task.content, taskId})
  }

  deleteTask(key, taskId){
    confirm(__('Proceed to delete notes?', locale))
    .then(() => {
      this.props.deleteContactNotes(key, taskId)
      this.getContactNotes()
    })
    .catch(() => {})
  }

  render() {
    const {contactNotes, contactId} = this.props;
    const {result_list, total_amount, hasPermission} = contactNotes;
    const {status, content, taskId, disabledBtn} = this.state;
    const onBoardingContent = onBoardingContents;

    if((total_amount == 0 && onBoardingContent && status != 'add') || !hasPermission){
      return(
        <div className='contact-notes-container'>
          <div className='contact-notes-header'>
            <h4 className='pull-left'>{__('Contact Notes', locale)}</h4>
            <__R can='edit_contact_notes' by='disable'>
              <button className=' pull-right btn btn-primary' onClick={() => {
                this.setState({status: 'add', content: ''})
              }}>{__('Add', locale)}</button>
            </__R>
          </div>
          <OnBoardingNatural isShown={true} title={onBoardingContent.title} text={onBoardingContent.text} image={onBoardingContent.image} showArrow={onBoardingContent.showArrow} />
        </div>
      )
    } else {
      return (
        <div className='contact-notes-container'>
          {status == 'view' && <div>
            <div className='contact-notes-header'>
              <h4 className='pull-left'>{__('Contact Notes', locale)}</h4>
              <__R can='edit_contact_notes' by='disable'>
                <button className=' pull-right btn btn-primary' onClick={() => {
                  this.setState({status: 'add', content: ''})
                }}>{__('Add', locale)}</button>
              </__R>
            </div>
            <ContactTimeline
              tasks={result_list}
              editTask={this.editTask}
              deleteTask={this.deleteTask}
            />
          </div>}
          {status == 'add' && <div>
            <h3 style={{marginBottom: '20px'}}>{__('Add Contact Notes', locale)}</h3>
            <ReactQuill value={content} onChange={(value) => {
              this.setState({content: value})
            }} />
            <button className='btn btn-primary' disabled={disabledBtn} onClick={() => {
              this.setState({disabledBtn: true})
              this.props.addContactNotes(contactId, {content}, () => {
                this.getContactNotes()
                this.setState({status: 'view', content: '', disabledBtn: false})
              })
            }}>{__('Save', locale)}</button>
            <button className='btn btn-default' onClick={() => {
              this.setState({status: 'view', content: ''})
            }}>{__('Cancel', locale)}</button>
          </div>}
          {status == 'edit' && <div>
            <h3 style={{marginBottom: '20px'}}>{__('Edit Contact Notes', locale)}</h3>
            <ReactQuill value={content} onChange={(value) => {
              this.setState({content: value})
            }}/>
            <button className='btn btn-primary' disabled={disabledBtn} onClick={() => {
              this.setState({disabledBtn: true})
              this.props.updateContactNotes(taskId, {content}, () => {
                this.getContactNotes()
                this.setState({status: 'view', content: '', disabledBtn: false})
              })
            }}>{__('Save', locale)}</button>
            <button className='btn btn-default' onClick={() => {
              this.setState({status: 'view', content: ''})
            }}>{__('Cancel', locale)}</button>
          </div>}
        </div>
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactNotes);



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/index.js